module.exports = "<mat-list-item>\r\n  <mat-icon mat-list-avatar>layers</mat-icon>\r\n  <h4 mat-line\r\n    [matTooltip]=\"layer.title\"\r\n    matTooltipShowDelay=\"500\">\r\n    {{layer.title}}\r\n  </h4>\r\n</mat-list-item>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/catalog/catalog-layer-item/catalog-layer-item.component.html
// module id = 1057
// module chunks = 0